module.exports = __webpack_public_path__ + "img/product_77.7137f1b.webp";